import { appVersion } from './version'

export const environment = {
  production: true,
  environmentName: 'Development',
  baseUrl: 'https://api.tgmob-dev.prolins.com.br/api/',
  googleMapsApiKey: 'key',
  version: appVersion,
}
